import React, { useState, useEffect } from 'react'
import NewsButton from './newsButton'
import NewsResume from './newsResume'
import NewsPanel from './newsPanel'
import { getNews, setNewAsRead } from '../../../helpers/restHelpers'
import routes from '../../router/routes'
import { withRouter } from 'react-router'

const News = (props) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [news, setNews] = useState([])
    const [unreadNews, setUnreadNews] = useState([])
    const [readNews, setReadNews] = useState([])
    const [openPanel, setOpenPanel] = useState(false)

    useEffect(() => {
        const getAllNews = async () => {
            setNews(await getNews())
        }
        getAllNews()
    }, [readNews.length])

    useEffect(() => {
        const restrictiveNew = news.find((oneNew) => oneNew.type === 2 && !oneNew.read)
        setUnreadNews((news.filter((oneNew) => !oneNew.read)))
        setReadNews(news.filter((oneNew) => oneNew.read))
        if (restrictiveNew) {
            props.history.push(routes.restrictiveNew.path)
        }
    }, [news, props.history])

    const handleClick = (e) => {
        anchorEl !== null ? setAnchorEl(null) : setAnchorEl(e.currentTarget)
    }

    const openNewsPanel = () => {
        setOpenPanel(true)
        setAnchorEl(null)
    }

    const closeNewsPanel = () => {
        setOpenPanel(false)
    }

    const handleNewsRead = (oneNew, checked, newId) => {
        if ((oneNew.type === 4 && checked) || (oneNew.type === 1)) {
            setNewAsRead(newId).then(() => {
                const updateNews = news.map((n) => {
                    if (n.id === oneNew.id) {
                        return { ...n, 'read': true }
                    }
                    return n
                })
                setNews(updateNews)
            })
        }
    }

    return (
        <div>
            <NewsButton handleClick={handleClick} unreadNews={unreadNews} />
            <NewsResume anchorEl={anchorEl} openNewsPanel={openNewsPanel} openPanel={openPanel} handleClick={handleClick} news={unreadNews} />
            <NewsPanel openPanel={openPanel} closeNewsPanel={closeNewsPanel} readNews={readNews} unreadNews={unreadNews} handleNewsRead={handleNewsRead} />
        </div>
    )
}

export default withRouter(News)
